import { useState } from "react";
import "react-confirm-alert/src/react-confirm-alert.css";
import Comments from "./Comments";

const FormCheckbox = ({
  name,
  label,
  checked,
  error,
  className,
  divClassName,
  labelClassName,
  commentsFactory,
  divStyle,
  disabled,
  padded,
  ...rest
}) => {
  const [showComments, setShowComments] = useState(false);

  const toggleComments = () => {
    setShowComments(!showComments);
  };

  const comments = commentsFactory?.get(name);

  return (
    <>
      {comments && showComments ? (
        <Comments comments={comments} commentsFactory={commentsFactory} />
      ) : null}
      <div
        className={`d-print-none clearfix ${
          divClassName ? ` ${divClassName}` : ""
        }`}
        style={divStyle}
      >
        <div className="form-check d-flex align-items-center">
          <input
            {...rest}
            name={name}
            id={name}
            checked={checked}
            type="checkbox"
            className={`form-check-input cbox border-secondary${
              className ? ` ${className}` : ""
            }`}
            disabled={disabled}
          />
          <label
            className={`form-check-label flex-fill ms-2${
              labelClassName ? ` ${labelClassName}` : ""
            }`}
            htmlFor={name}
            style={
              padded && {
                paddingLeft: "1.25em",
                textIndent: "-1.25em",
              }
            }
          >
            <span
              className={`d-none d-print-inline ${
                checked ? "checked" : "not-checked"
              }`}
            />
            {label}
            {comments?.length > 0 ? (
              <i
                className="fas fa-comment-alt text-warning m-2"
                onClick={toggleComments}
              />
            ) : null}
          </label>
          {error && <div className="alert alert-danger">{error}</div>}
        </div>
      </div>
      <div
        className={`d-none d-print-inline clearfix mb-3${
          divClassName ? ` ${divClassName}` : ""
        }`}
        style={divStyle}
      >
        <div className="form-check d-flex align-items-center">
          <input
            {...rest}
            name={name}
            id={name}
            checked={checked}
            type="checkbox"
            className={`form-check-input cbox ${
              className ? ` ${className}` : ""
            }`}
            disabled={false}
          />
          <label
            className={`form-check-label flex-fill ms-2${
              labelClassName ? ` ${labelClassName}` : ""
            }`}
            htmlFor={name}
            style={{
              paddingLeft: "1.25em",
              textIndent: "-1.25em",
            }}
          >
            <span
              className={`d-none d-print-inline ${
                checked ? "checked" : "not-checked"
              }`}
            />
            {label}
          </label>
          {error && <div className="mt-1 alert alert-danger">{error}</div>}
        </div>
      </div>
    </>
  );
};

export default FormCheckbox;
